// trim() removes any add'l space (in case firstName or lastName is an empty string, for example)
const getFullName = (
  person?: { firstName: string; lastName: string } | null
) => (person ? `${person.firstName} ${person.lastName}`.trim() : "");

export default getFullName;
